export { CategoriesContainer as Categories } from './container';
